"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _default = function _default(key, options) {
  _I18n.default.Info.then(function () {
    document.title = _I18n.default.text(key, options);
  });
};

exports.default = _default;
module.exports = exports.default;